import React from 'react';
// import './AboutUsSection.css';

const AboutUsSection = () => {
    const expertiseKeywords = [
        { label: "Pre-Wedding & Wedding", icon: "fa-ring" },
        { label: "Modeling & Acting", icon: "fa-user-tie" },
        { label: "Commercial & Industrial", icon: "fa-industry" },
        { label: "Fashion & Beauty", icon: "fa-wand-magic-sparkles" },
        { label: "Product & Brand", icon: "fa-box-open" },
        { label: "Event & Celebration", icon: "fa-champagne-glasses" },
        { label: "Creative & Fine Art", icon: "fa-palette" },
        { label: "Maternity & Baby", icon: "fa-baby" },
        { label: "Love & Family", icon: "fa-heart-pulse" },
        { label: "Celebrity & Movie Poster", icon: "fa-clapperboard" }
    ];

    return (
        <section className="about-us-section py-6" style={{ backgroundImage: 'url(/home/about-khultstudios.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', minHeight: '400px' }}>
            <div className="container">
                <div className="row align-items-center g-5">
                    
                    {/* Left Side: Editorial Content & Typography */}
                    <div className="col-lg-6 col-12 text-content-side">
                        <div className="section-badge-container mb-3">
                            <span className="section-subtitle-pill">Who We Are</span>
                        </div>
                        <h2 className="about-main-title text-uppercase mb-4">
                            Crafting Visual Legacies <br />
                            <span className="brand-highlight">At KhultStudios</span>
                        </h2>
                        
                        <p className="about-description mb-4">
                            KhultStudios operates at the precise convergence of high-fashion editorials, 
                            cinematic storytelling, and commercial grandeur. We don't merely document moments; 
                            we construct timeless monuments of lighting, perspective, and emotion. 
                        </p>
                        
                        <p className="about-description mb-5">
                            Whether framing a raw cinematic movie poster composition, an elegant avant-garde fashion lineup, 
                            or capturing the intimate poetry of family milestones, our team brings meticulous execution 
                            and agency-grade production value to every frame.
                        </p>

                        {/* Statistics Grid */}
                        <div className="stats-row row g-4 mb-5">
                            <div className="col-sm-4 col-6">
                                <div className="stat-box">
                                    <h3 className="stat-number">12+</h3>
                                    <p className="stat-label">Years of Excellence</p>
                                </div>
                            </div>
                            <div className="col-sm-4 col-6">
                                <div className="stat-box">
                                    <h3 className="stat-number">850+</h3>
                                    <p className="stat-label">Elite Portfolios</p>
                                </div>
                            </div>
                            <div className="col-sm-4 col-12">
                                <div className="stat-box">
                                    <h3 className="stat-number">25+</h3>
                                    <p className="stat-label">Global Awards</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Side: Visual Keyword Matrix Grid */}
                    <div className="col-lg-6 col-12 visual-matrix-side">
                        <div className="matrix-headline-box mb-4">
                            <h4 className="matrix-title text-uppercase">Areas of Domain Mastery</h4>
                            <div className="accent-line"></div>
                        </div>

                        {/* Interactive Keywords Grid */}
                        <div className="keywords-flex-grid">
                            {expertiseKeywords.map((item, index) => (
                                <div key={index} className="keyword-matrix-card">
                                    <div className="keyword-icon-wrapper">
                                        <i className={`fa-solid ${item.icon}`}></i>
                                    </div>
                                    <div className="keyword-info">
                                        <span className="keyword-index">{(index + 1).toString().padStart(2, '0')}</span>
                                        <h5 className="keyword-label">{item.label}</h5>
                                    </div>
                                    <div className="card-hover-border"></div>
                                </div>
                            ))}
                        </div>

                        {/* Split Decorative Frame Backdrop */}
                        <div className="composite-image-backdrop">
                            <div 
                                className="decorative-img-frame image-one"
                                style={{ backgroundImage: `url('https://images.unsplash.com/photo-1542038784456-1ea8e935640e?q=80&w=800')` }}
                            />
                            <div 
                                className="decorative-img-frame image-two"
                                style={{ backgroundImage: `url('https://images.unsplash.com/photo-1516035069371-29a1b244cc32?q=80&w=800')` }}
                            />
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default AboutUsSection;